import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SalesPageRoutingModule } from './sales-routing.module';

import { SalesPage } from './sales.page';

import { StylistPickerModule } from '../components/stylist-picker/stylist-picker.module';
import { SalonMonsterDatePickerModule } from '../components/smr-date-picker/smr-date-picker.module';
import { SharedModule } from '../shared.module';
import { SalonMonsterLoadMaskModule } from '../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../components/smr-tap-retry/smr-tap-retry.module';
import { ClientPickerModule } from '../components/smr-client-picker/smr-client-picker.module';
import { SaleListComponentModule } from '../components/sale-list/sale-list.module';
//import { SaleListComponent } from '../../components/sale-list/sale-list.component';

import { SalesSharedPageModule } from './sales-shared/sales-shared.module';

import { UniversalSearchComponentModule } from '../components/universal-search/universal-search.module';
import { MenuButtonComponentModule } from '../components/smr-menu-button/smr-menu-button.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SalesPageRoutingModule,
    SalonMonsterLoadMaskModule,
    ClientPickerModule,
    StylistPickerModule,
    SharedModule,
    SalonMonsterTapRetryModule,
    SaleListComponentModule,
   // SaleListComponent,
    SalonMonsterDatePickerModule,
    SalesSharedPageModule,
    UniversalSearchComponentModule,
    MenuButtonComponentModule
  ],
  declarations: [SalesPage]
})
export class SalesPageModule {}
